import React, { Dispatch, ReactElement } from 'react';
import { Form, PageHeader, PageHeaderProps } from 'antd';
import styled from 'styled-components';

import ContractListFiltersForm from 'pricing/components/contractList/contractListFilters/contractListFiltersForm/ContractListFiltersForm';
import { ContractListingAction } from 'pricing/pages/contractList/ContractList.state';
import ContractListFiltersTitle from 'pricing/components/contractList/contractListFilters/contractListFiltersTitle/ContractListFiltersTitle';

export const PageHeaderStyled = styled(PageHeader)`
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
`;

interface Props extends PageHeaderProps {
  dispatch: Dispatch<ContractListingAction>;
  resultsCounts?: number;
}

function ContractListFilters(props: Props): ReactElement {
  const { dispatch, resultsCounts } = props;
  const [form] = Form.useForm();

  return (
    <PageHeaderStyled
      title={
        <ContractListFiltersTitle
          form={form}
          dispatch={dispatch}
          resultsCounts={resultsCounts}
        />
      }
      extra={<ContractListFiltersForm form={form} dispatch={dispatch} />}
    />
  );
}

export default ContractListFilters;
